import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.625 6H1.375",
			stroke: "#262626",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.625 0.75L1.375 6L6.625 11.25",
			stroke: "#262626",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2214%22%20height%3D%2212%22%20viewBox%3D%220%200%2014%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M12.625%206H1.375%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.625%200.75L1.375%206L6.625%2011.25%22%20stroke%3D%22%23262626%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E%0A";
